import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";


const getList = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.documents.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const updateDocument = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

	const payload = {
		...data,
		authenticity_token: authenticity_token,
	}

	const endpoint = api.admin.documents.update.replace('{documentId}', `${data.documentId}`);

	return fetch(`${endpoint}?authenticity_token=${authenticity_token}`, {...RequestOptions('PUT', JSON.stringify(payload))})
		.then(handleResponse)
		.then(
			data => {
				return data;
			}
		)
		.catch((error) => {
			return error
		});
};

export const documentsService = {
	getList,
	updateDocument,
};
